import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Component({
  selector: 'app-auth-handler',
  template: '<p>Redirecting...</p>',
  standalone: true,
})
export class AuthHandleComponent implements OnInit {
  constructor(private authService: MsalService, private router: Router) {}

  ngOnInit(): void {
    this.authService
      .handleRedirectObservable()
      .subscribe((result: AuthenticationResult | null) => {
        if (result) {
          this.authService.instance.setActiveAccount(result.account);
          this.router.navigate(['/']);
        } else {
          const account = this.authService.instance.getAllAccounts()[0];
          if (account) {
            this.authService.instance.setActiveAccount(account);
            this.router.navigate(['/']);
          } else {
            this.authService.loginRedirect();
          }
        }
      });
  }
}
